import { useMediaQuery } from 'usehooks-ts';

/**
 * Uses a hard coded to media match size to prevent needing to [resolve Tailwind config](https://tailwindcss.com/docs/configuration#referencing-in-java-script); comes from [their default breakpoints](https://tailwindcss.com/docs/screens).
 * Represents if the current viewport is at least "desktop"/"laptop" size.
 */
export default function useIsDesktop() {
  return useMediaQuery('(min-width: 1024px)');
}
